import { ButtonType } from "./button-type.enum";

export const buttonTypeOptions = [
  {
    key: 'Default',
    value: ButtonType.Default
  },
  {
    key: 'Primary',
    value: ButtonType.Primary
  },
  {
    key: 'Dashed',
    value: ButtonType.Dashed
  },
  {
    key: 'Link',
    value: ButtonType.Link
  }
];
